import { normalizeAdvertisersCategories } from '@/lib/adapters/advertisers.adapter'
import { normalizeAffiliateLink } from '@/lib/adapters/affiliate-link.adapter'
import { normalizeMoney } from '@/lib/adapters/common.adapter'
import { normalizeImage } from '@/lib/adapters/image.adapter'
import { makeQueryString } from '@/lib/helpers/query.helpers'
import type {
  ReturnAdListItemServerType,
  ReturnAdListItemType,
  ReturnAdsFilterType,
} from '@/lib/types/return-ads.types'

export const normalizeListReturnAd = (ad: ReturnAdListItemServerType): ReturnAdListItemType => {
  return {
    id: ad.id,
    internalName: ad.name,
    advertiserGroup: ad.advertiser_group_id,
    affiliateLink: normalizeAffiliateLink(ad.affiliate_link),
    authorId: ad.author_id,
    status: ad.status,
    isAllAdvertisersSelected: ad.display_for_all_advertisers,
    categories: ad.advertiser_categories
      ? normalizeAdvertisersCategories(ad.advertiser_categories)
      : [],
    advertiserList: ad.advertisers
      ? ad.advertisers.map((item) => ({ id: item.id, label: item.name }))
      : [],
    styles: ad.styles,
    startsAt: ad.starts_at,
    endsAt: ad.ends_at,
    ...(ad.image && {
      image: normalizeImage(ad.image),
    }),
    stats: {
      orderCount: ad.stats.order_count,
      orderValue: normalizeMoney(ad.stats.order_value),
      earnings: normalizeMoney(ad.stats.earnings),
      currentClicks: ad.stats.current_clicks,
      currentViews: ad.stats.current_views,
      clickThroughRate: ad.stats.click_through_rate,
      conversionRate: ad.stats.conversion_rate,
    },
    clickLimit: ad.click_limit,
    viewLimit: ad.view_limit,
  }
}

export const normalizeReturnAds = (ads: ReturnAdListItemServerType[]): ReturnAdListItemType[] => {
  return ads.map(normalizeListReturnAd)
}

const handleFilter = (filter: ReturnAdsFilterType, id: number): ReturnAdsFilterType => {
  const result = { ...filter }

  delete result.createdByMe

  if (filter.createdByMe) {
    result.createdBy = id
  }

  return result
}

export const makeQueryStringForReturnAds = (
  filter: ReturnAdsFilterType,
  id: number,
): string | null => {
  const updatedFilter = handleFilter(filter, id)

  return makeQueryString(updatedFilter, true)
}
